import { gql } from "@apollo/client";
export const EDIT_ORGANIZATION = gql `
  mutation EditOrganization($id: ID!, $data: organizationInput!) {
    editOrganization(id: $id, data: $data) {
      id
    }
  }
`;
